export enum ContainerEnvironment {
  Prod = 'Prod',
  Dogfood = 'Dogfood',
  Local = 'Local'
}
